/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DelayChannelFragment = {
	id: string;
	description: {
		groupName: string;
		constraints: { delay: { delay: { range: { min: string; max: string; step: string } } } | null };
		features: { channelConfiguration: { supported: boolean } };
	};
	features: {
		name: { name: string } | null;
		delay: { enabled: boolean; delay: string } | null;
		channelConfiguration: { enabled: boolean } | null;
	};
};

export type DelayChannelUpdateFragment = {
	id: string;
	features:
		| { channelConfiguration: { enabled: boolean } | null }
		| { delay: { enabled: boolean; delay: string } | null }
		| { name: { name: string } | null }
		| {};
};

export type DelayChannelQueryVariables = Types.Exact<{
	channelId: Types.Scalars['ID']['input'];
}>;

export type DelayChannelQueryOpResult = { node: DelayChannelFragment | {} };

export type DelayChannelSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type DelayChannelSubscriptionOpResult = { nodeChanges: DelayChannelFragment | DelayChannelUpdateFragment | {} };

export type DelayChannelMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type DelayChannelMutationOpResult = {
	updateNodes: Array<{ error: { code: Types.ErrorCode; message: string } | null } | {}>;
};

export const DelayChannelFragment = gql`
	fragment DelayChannelFragment on AudioChannel {
		id
		description {
			groupName
			constraints {
				delay {
					delay {
						range {
							min
							max
							step
						}
					}
				}
			}
			features {
				channelConfiguration {
					supported
				}
			}
		}
		features {
			name {
				name
			}
			delay {
				enabled
				delay
			}
			channelConfiguration {
				enabled
			}
		}
	}
`;
export const DelayChannelUpdateFragment = gql`
	fragment DelayChannelUpdateFragment on AudioChannelChange {
		id
		features {
			... on AudioChannelNameChange {
				name {
					name
				}
			}
			... on AudioChannelDelayChange {
				delay {
					enabled
					delay
				}
			}
			... on AudioChannelChannelConfigurationChange {
				channelConfiguration {
					enabled
				}
			}
		}
	}
`;
export const DelayChannelQueryDocument = gql`
	query DelayChannelQuery($channelId: ID!) {
		node(id: $channelId) {
			...DelayChannelFragment
		}
	}
	${DelayChannelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class DelayChannelQueryGQL extends Apollo.Query<DelayChannelQueryOpResult, DelayChannelQueryVariables> {
	override document = DelayChannelQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const DelayChannelSubscriptionDocument = gql`
	subscription DelayChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			... on AudioChannel {
				...DelayChannelFragment
			}
			... on AudioChannelChange {
				...DelayChannelUpdateFragment
			}
		}
	}
	${DelayChannelFragment}
	${DelayChannelUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class DelayChannelSubscriptionGQL extends Apollo.Subscription<
	DelayChannelSubscriptionOpResult,
	DelayChannelSubscriptionVariables
> {
	override document = DelayChannelSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const DelayChannelMutationDocument = gql`
	mutation DelayChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on AudioChannelOperationResult {
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class DelayChannelMutationGQL extends Apollo.Mutation<
	DelayChannelMutationOpResult,
	DelayChannelMutationVariables
> {
	override document = DelayChannelMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
